__turbopack_context__.v({
  "root": "LinkWithArrow-module__A2r7ca__root",
});
